import React, { Fragment, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Seo from "./common/Seo";

import Header from "./Header/Header";
import HeaderInternal from "./Header/HeaderInternal";
import Top from "./SeriesPreview/Top";
import PreviewVideo from "./SeriesPreview/PreviewVideo";
import App from "./SeriesPreview/App";
import Testimonials from "./SeriesPreview/Testimonials";
import FAQs from "./SeriesPreview/FAQs";
import Footer from "./Footer/Footer";
import { AccountContext } from "../store/AccountContext";
import { Navigate } from "react-router-dom";
import TestimonialItems from "./SeriesPreview/CarsehallTestimonials.json";
// import { OverviewContext } from "../store/OverviewContext";
// import DoorsClosingCountdown from "./Banners/DoorsClosingCountdown";

// Styles
const useStyles = makeStyles((theme) => ({
  container: {
    // @ts-ignore
    backgroundColor: theme.palette.background.ffNavy,
  },
}));

const CarsehallFarm = () => {
  const classes = useStyles();
  const { loggedIn } = useContext(AccountContext);
  // const { overview } = useContext(OverviewContext);

  return (
    <div className={classes.container}>
      {loggedIn ? <Navigate to="/videos" replace /> : null}
      <Seo
        title="Watch Carsehall Farm only on FarmFLiX"
        description="Watch the entire series of Carsehall Farm only on FarmFLiX."
        path="/carsehallfarm"
      />
      {loggedIn && <HeaderInternal />}
      {!loggedIn && <Header />}
      {/* {overview && overview.doors?.open && <DoorsClosingCountdown />} */}
      <Top
        title="Carsehall Farm"
        backgroundImg="https://community-assets-prod.farmflix.tv/21/10/29/c8d769f0-8fba-4542-a098-e4db16741402/full"
        channelImg="https://farmflix-images-prod.s3.eu-west-1.amazonaws.com/Merch/aglife_thumb.png"
        year={2021}
        seasonCount={1}
        episodeCount={7}
        backgroundPositionSm="40%"
        backgroundPositionXl="50%"
      />
      <PreviewVideo
        titleSmall={
          <Fragment>
            A <span>quick glimpse</span> into
          </Fragment>
        }
        titleLarge="Carsehall Farm"
        description="Carsehall Farm is a mixed dairy and arable unit on the outskirts of Limavady owned and managed by the Craig family"
        videoId="carsehall-farm-series-compilation"
      />

      <App title="Carsehall Farm" />
      <Testimonials data={TestimonialItems} />
      <FAQs />
      <Footer />
    </div>
  );
};

export default CarsehallFarm;
